import { render } from "./Ramp.vue?vue&type=template&id=0e4b580c"
import script from "./Ramp.vue?vue&type=script&lang=ts"
export * from "./Ramp.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSeparator,QBtn});
